import { render, staticRenderFns } from "./RatesWaitTimeDetails.vue?vue&type=template&id=fd5537a6&scoped=true&"
import script from "./RatesWaitTimeDetails.vue?vue&type=script&lang=js&"
export * from "./RatesWaitTimeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesWaitTimeDetails.vue?vue&type=style&index=0&id=fd5537a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5537a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd5537a6')) {
      api.createRecord('fd5537a6', component.options)
    } else {
      api.reload('fd5537a6', component.options)
    }
    module.hot.accept("./RatesWaitTimeDetails.vue?vue&type=template&id=fd5537a6&scoped=true&", function () {
      api.rerender('fd5537a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesWaitTimeDetails.vue"
export default component.exports